$ = require 'jquery'
WarningBannerView = require 'views/header/warning-banner-view'
Auth = require 'db/auth'
Controller = require 'controller'
templates = require 'views/internal/templates'
track = require 'debug/track'

module.exports = class OverdueBannerView extends WarningBannerView
  events:
    'click .js-update-billing-information': 'updateBillingInformation'
    'click .js-dismiss-overdue-banner': 'dismiss'

  getMessageName: ->
    paidAccount = @model.get('paidAccount')
    billingDate = new Date(paidAccount.billingDates?[paidAccount.products?[0]]).getTime()
    "OverdueBanner-#{@model.id}-#{billingDate}"

  render: ->
    data =
      team: @model.get('displayName')
      billingUrl: Controller.getOrganizationBillingUrl(@model)
    @$el.html templates.fill('header_overdue_banner', data)

    @

  updateBillingInformation: ->
    track("Header", "Overdue Banner", "Update billing information")
    Auth.me().dismiss @getMessageName()

  dismiss: (e) ->
    track("Header", "Overdue Banner", "Dismiss")
    Auth.me().dismiss @getMessageName()
    $('.header-banner').remove()
    e.preventDefault()



// WEBPACK FOOTER //
// ./app/scripts/views/header/overdue-banner-view.coffee